
<script>
import BaseEdit from '../../../share/admin/state/Edit'

export default {
  mixins: [
    BaseEdit
  ],
  data () {
    return {
      events: null,
      headerTitle: { title: 'Stany procesu', description: 'Tryb edycji' },
      service: this.$route.meta.acl.service,
      workflowName: this.$route.meta.workflow.split('-').join('_'),
      loginModalBackUrlName: ''
    }
  },
  created () {
    this.getInitEvents()
    this.getInitLoginModalBackUrlName()
  },
  methods: {
    getInitEvents () {
      this.events = {
        stateSubmit: `${this.service}:main:stateSubmit`
      }
    },
    getInitLoginModalBackUrlName () {
      this.loginModalBackUrlName = `${this.service}_${this.$route.meta.workflow.split('-')[1]}_state_listing`
    }
  }
}
</script>
